import { concatAxiosTransformer } from '../helper';
export default class Controllers {
    constructor(client) {
        this.client = client;
    }
    Get(controllerId) {
        return this.client.get(`/controllers/${controllerId}/rooms?details=true`, {
            transformResponse: concatAxiosTransformer(this.client.defaults.transformResponse, (rooms) => {
                return rooms.map((room) => {
                    room.state.changed_at = new Date(room.state.changed_at);
                    return room;
                });
            }),
        });
    }
    GetRoomDetail(controllerId, roomId) {
        return this.client.get(`/controllers/${controllerId}/rooms/${roomId}`, {
            transformResponse: concatAxiosTransformer(this.client.defaults.transformResponse, (room) => {
                room.state.changed_at = new Date(room.state.changed_at);
                return room;
            }),
        });
    }
}
